import {Application, Assets, Container} from "pixi.js";
import InteractionDecode from "../components/InteractionDecode.ts";
import InteractionDecodeOptions from "../types/InteractionDecodeOptions.ts";
import DecodingModel from "../models/DecodingModel.ts";

export default class MarkingActivity
{
    //private ROOT_ASSETS_PATH = "./assets";
    private ROOT_ASSETS_PATH = "/assets";

    private _codes:Array<string>;
    private _words:Array<string>;

    private app:Application | undefined;
    private code:string;
    private curInteractionIndex:number;
    private interactionDecode:InteractionDecode;
    private model:DecodingModel;
    private totalClicks:number;
    private totalCorrectClicks:number;
    private word:string;

    public isNonsenseWord:boolean;
    public previewMarks:boolean;

    public set codes(value:Array<string>)
    {
        this._codes = value;
    }

    public set words(value:Array<string>)
    {
        this._words = value;
    }

    constructor()
    {
        this._init();
    }

    private _init():void
    {
        this.curInteractionIndex = 0;
        this.model = DecodingModel.getInstance();
        this.isNonsenseWord = false;
        this.previewMarks = false;
        this.totalClicks = 0;
        this.totalCorrectClicks = 0;
    }

    private createInteractionDecode(firstInteraction=true):void
    {
        //this.interactionDecode = new InteractionDecode(new InteractionDecodeOptions("dog", "‹123›2x,‹1234›«3g»,2s"));
        //this.interactionDecode = new InteractionDecode(new InteractionDecodeOptions("dog", "2x,3g,2s"), ["l","g","x","s"]);
        //this.interactionDecode = new InteractionDecode(new InteractionDecodeOptions("electric", "1x,3x,5b,7x,1[,1],1l,2[,4],3s,5[,8],7s"), ["l","g","x","s"]);
        this.interactionDecode = new InteractionDecode(new InteractionDecodeOptions(this.word, this.code), null, this.isNonsenseWord, this.previewMarks);
        this.interactionDecode.firstInteraction = firstInteraction;
        this.interactionDecode.interactionCompleteCallback = this.onInteractionComplete;
        this.interactionDecode.isPrototype = true;
        this.interactionDecode.create();
        /*this.interactionDecode.pivot.set(this.interactionDecode.width/2, this.interactionDecode.height/2);
        this.interactionDecode.x = this.app.screen.width/2;
        this.interactionDecode.y = 346;*/
        this.app.stage.addChild(this.interactionDecode);
    }

    private destroyInteractionDecode():void
    {
        if(this.interactionDecode)
        {
            this.app.stage.removeChild(this.interactionDecode);
            this.interactionDecode.destroy();
            this.interactionDecode = null;
        }
    }

    private onInteractionComplete = (correctClicks:number, totalClicks:number):void =>
    {
        this.totalCorrectClicks += correctClicks;
        this.totalClicks += totalClicks;
        this.curInteractionIndex++;
        if(this.curInteractionIndex < this._words.length)
        {
            this.word = this._words[this.curInteractionIndex];
            this.code = this._codes[this.curInteractionIndex];
            this.destroyInteractionDecode();
            this.createInteractionDecode(false);
        }
        else
        {
            alert(`Total Correct Clicks: ${this.totalCorrectClicks}\nTotal Clicks: ${this.totalClicks}\nPercentage: ${Math.round((this.totalCorrectClicks/this.totalClicks)*100)}%`);
        }
    }


    private onLoadProgress = (progress:Number):void =>
    {
        console.log("onLoadProgress: "+progress+"%");
    }

    private async preloadAssets():Promise<void>
    {
        const bundle = [
            {
                alias: "mainbg",
                src: `${this.ROOT_ASSETS_PATH}/images/main-bg.png`
            },
            {
                alias: "door",
                src: `${this.ROOT_ASSETS_PATH}/images/door.png`
            },
            {
                alias: "vines",
                src: `${this.ROOT_ASSETS_PATH}/images/vines.png`
            },
            {
                alias: "track1",
                src: `${this.ROOT_ASSETS_PATH}/images/track1.png`
            },
            {
                alias: "track2",
                src: `${this.ROOT_ASSETS_PATH}/images/track2.png`
            },
            {
                alias: "track3",
                src: `${this.ROOT_ASSETS_PATH}/images/track3.png`
            },
            {
                alias: "beetle",
                src: `${this.ROOT_ASSETS_PATH}/images/beetle.png`
            },
            {
                alias: "tile1",
                src: `${this.ROOT_ASSETS_PATH}/images/tile1.png`
            },
            {
                alias: "tile2",
                src: `${this.ROOT_ASSETS_PATH}/images/tile2.png`
            },
            {
                alias: "tile3",
                src: `${this.ROOT_ASSETS_PATH}/images/tile3.png`
            },
            {
                alias: "tile4",
                src: `${this.ROOT_ASSETS_PATH}/images/tile4.png`
            },
            {
                alias: "splitBtn1",
                src: `${this.ROOT_ASSETS_PATH}/images/split-btn-1.png`
            },
            {
                alias: "splitBtn2",
                src: `${this.ROOT_ASSETS_PATH}/images/split-btn-2.png`
            },
            {
                alias: "splitBtn3",
                src: `${this.ROOT_ASSETS_PATH}/images/split-btn-3.png`
            },
            {
                alias: "star",
                src: `${this.ROOT_ASSETS_PATH}/images/star.svg`
            },
            {
                alias:"sweaterschoolreg",
                src:`${this.ROOT_ASSETS_PATH}/fonts/sweaterschoolreg.ttf`
            },
            {
                alias:"rhdicons",
                src:`${this.ROOT_ASSETS_PATH}/fonts/rhdicons.ttf`
            },
            {
                alias: "nonsense",
                src: `${this.ROOT_ASSETS_PATH}/images/nonsense.svg`
            },
            {
                alias: "guardianstar",
                src: `${this.ROOT_ASSETS_PATH}/images/star.svg`
            },
        ];

        await Assets.init();
        Assets.addBundle("decoding", bundle);
        this.model.assets = await Assets.loadBundle('decoding', this.onLoadProgress);
    }

    public async create():Promise<void>
    {
        let errorsFound = false;
        if(this._words == null || this._words.length == 0)
        {
            alert("ERROR: No words to decode!");
            errorsFound = true;
        }
        if(this._codes == null || this._codes.length == 0)
        {
            alert("ERROR: No codes provided!");
            errorsFound = true;
        }
        if(errorsFound)
        {
            return;
        }
        const pixiAppConfig = {
            antialias: true,
            background: "#000000",
            width: 1366,
            height: 768,
            canvas: document.getElementById('pixi-canvas') as HTMLCanvasElement,
            resolution: window.devicePixelRatio || 1,
            autoDensity: true,
        };
        this.app = new Application();
        this.app.stage.label = "Marking Activity";
        await this.app.init(pixiAppConfig);
        //this.app.renderer.events.cursorStyles.hover = "pointer";
        this.model.app = this.app;

        this.preloadAssets().then(() => {
            this.word = this._words[this.curInteractionIndex];
            this.code = this._codes[this.curInteractionIndex];
            this.createInteractionDecode();
        });
        await Promise.resolve();
    }

    public destroy(destroyApp=false):void
    {
        if(this.app)
        {
            if(this.interactionDecode)
            {
                this.app.stage.removeChild(this.interactionDecode);
                this.interactionDecode.destroy();
                this.interactionDecode = null;
            }
            if(destroyApp)
            {
                this.app.destroy(true);
                this.app = null;
            }
        }
    }

    public getStage():Container | undefined
    {
        return this.app?.stage;
    }

    public resize(width: number, height: number): void {
        //debugger;
        if (this.app.renderer) {
            this.app.renderer.resize(width, height);
        }
    }
}